<div class="loader-content d-flex align-items-center justify-content-center">
  <img src="assets/loading/_loader.gif" alt="Logo Animation">
</div>
